import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'gt-dialer',
  templateUrl: './dialer.component.html',
  styleUrls: ['./dialer.component.scss']
})
export class DialerComponent {
  @Output() dial: EventEmitter<string> = new EventEmitter<string>();

  dialerButtons: DialerButton[] = [
    {
      text: '1',
      subText: '&nbsp'
    },
    {
      text: '2',
      subText: 'ABC'
    },
    {
      text: '3',
      subText: 'DEF'
    },
    {
      text: '4',
      subText: 'GHI'
    },
    {
      text: '5',
      subText: 'JKL'
    },
    {
      text: '6',
      subText: 'MNO'
    },
    {
      text: '7',
      subText: 'PQRS'
    },
    {
      text: '8',
      subText: 'TUV'
    },
    {
      text: '9',
      subText: 'WXYZ'
    },
    {
      text: '*',
      subText: ''
    },
    {
      text: '0',
      subText: '+'
    },
    {
      text: '#',
      subText: ''
    }
  ];

  onClick(value: string) {
    this.dial.next(value);
  }
}

export interface DialerButton {
  text: string;
  subText: string;
}
